export default "__VITE_ASSET__52429898__"